/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const patchApiFeedbacksIdMessagesMessageidReadPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор чата"),
"MessageId": z.string().uuid().describe("Идентификатор сообщения")
    })

/**
 * @description Сообщение помечено прочитанным
 */
export const patchApiFeedbacksIdMessagesMessageidRead200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации
 */
export const patchApiFeedbacksIdMessagesMessageidRead400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const patchApiFeedbacksIdMessagesMessageidRead401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const patchApiFeedbacksIdMessagesMessageidRead403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не найден | Сообщение не найдено | Чат не найден
 */
export const patchApiFeedbacksIdMessagesMessageidRead404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const patchApiFeedbacksIdMessagesMessageidRead500Schema = z.lazy(() => badResponseModelSchema)

export const patchApiFeedbacksIdMessagesMessageidReadMutationResponseSchema = z.lazy(() => patchApiFeedbacksIdMessagesMessageidRead200Schema)